var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCurrencyExchange = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "currency-exchange_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  mask: "url(#currency-exchange_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.61 12.38C.87 14.76 0 17.42 0 20.33s.87 5.57 2.61 7.96c1.74 2.39 4.09 4 7.06 4.85v-2.89c-2.03-.72-3.68-1.99-4.97-3.79-1.28-1.81-1.92-3.85-1.92-6.12s.64-4.32 1.92-6.14c1.28-1.82 2.94-3.07 4.97-3.78V7.53c-2.96.84-5.31 2.46-7.06 4.85ZM27.02 30.23c-1.22.44-2.45.66-3.69.66-2.91 0-5.39-1.03-7.46-3.1-2.06-2.06-3.1-4.55-3.1-7.46s1.03-5.39 3.1-7.46c2.06-2.06 4.55-3.1 7.46-3.1 1.24 0 2.47.22 3.69.67 1.22.45 2.3 1.1 3.26 1.94l1.89-1.92a12.2 12.2 0 0 0-4.12-2.6c-1.55-.58-3.12-.88-4.71-.88-3.66 0-6.79 1.31-9.41 3.92-2.62 2.62-3.92 5.75-3.92 9.41s1.31 6.79 3.92 9.41c2.62 2.62 5.75 3.92 9.41 3.92 1.59 0 3.16-.29 4.71-.88 1.55-.59 2.92-1.45 4.12-2.6l-1.89-1.89c-.95.84-2.04 1.48-3.26 1.92v.04Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m33.53 13.81-1.97 1.97 3.19 3.19H22l3.19-3.19-1.97-1.97-6.47 6.47 6.47 6.47 1.97-1.97-3.19-3.2h12.75l-3.19 3.2 1.97 1.97L40 20.28l-6.47-6.47Z"
}))));
export default SvgCurrencyExchange;